var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99844 2.40002H17.9984C19.9867 2.40002 21.5984 4.0118 21.5984 6.00002V18C21.5984 19.9882 19.9867 21.6 17.9984 21.6H5.99844C4.01021 21.6 2.39844 19.9882 2.39844 18V6.00002C2.39844 4.0118 4.01021 2.40002 5.99844 2.40002Z",
    fill: "#3DD598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83208 11.136C8.36042 10.6705 7.60064 10.6754 7.13506 11.147C6.66947 11.6187 6.67439 12.3785 7.14605 12.8441L10.1952 15.854C10.6968 16.3491 11.5152 16.3074 11.9638 15.7637L16.9146 9.7637C17.3364 9.25251 17.264 8.49618 16.7528 8.07438C16.2416 7.65258 15.4853 7.72504 15.0635 8.23622L10.9476 13.2243L8.83208 11.136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green_check.e61d84cb1843109409783baeac8cead6.svg";
export { ForwardRef as ReactComponent };